// routes.ts
import React from 'react';

import AccountPage from './pages/Account/AccountPage';
import ProfilePage from './pages/Profile/ProfilePage';
import AiModelPage from './pages/AiModel/AiModelPage';
import AiPersonaPage from './pages/AiPersona/AiPersonaPage';
import BlogEditPage from './pages/BlogEdit/BlogEditPage';
import BrandVoicePage from './pages/BrandVoice/BrandVoicePage';
import CreateAiPersonaPage from './pages/CreateAiPersona/CreateAiPersonaPage';
import CreateBlogPage from './pages/CreateBlog/CreateBlogPage';
import CreateStyleGuidePage from './pages/CreateStyleGuidePage/CreateStyleGuidePage';
import HomePage from './pages/Home/HomePage';
import LoginPage from './pages/Login/LoginPage';
import MyBlogPage from './pages/MyBlog/MyBlogPage';
import OnboardingPage from './pages/Onboarding/OnboardingPage';
import RegisterPage from './pages/Register/RegisterPage';
import VerifyEmail from './pages/VerifyEmailPage/VerifyEmailPage';
import CardDetails from './pages/PlanCheckout/PlanCheckout';
import CreateBlogIframe from './components/CreateBlogIframe/CreateBlogIframe';
import BlogJourneyPage from './pages/BlogJourney/BlogJourneyPage';
import TrialSuccess from './pages/TrialSuccess/TrialSuccess';
import SupportTicketsPage from './pages/SupportTickets/SupportTicketsPage';
import GeoScanPage from './pages/GeoScan/GeoScanPage';
import AeoScanPage from './pages/AeoScan/AeoScanPage';

export interface RouteInterface {
  id: number;
  path: string;
  label: string;
  element: React.ReactNode;
  layout: string;
}

const routes: RouteInterface[] = [
  {
    id: 1,
    path: '/',
    label: 'Home',
    element: <HomePage />,
    layout: 'private'
  },
  {
    id: 2,
    path: '/login',
    label: 'Login',
    element: <LoginPage />,
    layout: 'public'
  },
  {
    id: 3,
    path: '/register',
    label: 'Register',
    element: <RegisterPage />,
    layout: 'public'
  },
  {
    id: 4,
    path: '/onboarding',
    label: 'Onboarding',
    element: <OnboardingPage />,
    layout: 'public'
  },
  {
    id: 100,
    path: '/trial-success',
    label: 'Trial Success',
    element: <TrialSuccess />,
    layout: 'public'
  },

  {
    id: 5,
    path: '/createblog',
    label: 'CreateBlog',
    element: <CreateBlogPage />,
    layout: 'private'
  },
  {
    id: 6,
    path: '/blog-edit/:id',
    label: 'Blog Edit',
    element: <BlogEditPage />,
    layout: 'private'
  },
  {
    id: 7,
    path: '/my-blog',
    label: 'My Blog',
    element: <MyBlogPage />,
    layout: 'private'
  },
  {
    id: 8,
    path: '/brand-voice',
    label: 'Brand Voice',
    element: <BrandVoicePage />,
    layout: 'private'
  },
  {
    id: 9,
    path: '/blog-guideline',
    label: 'Ai Persona',
    element: <AiPersonaPage />,
    layout: 'private'
  },
  {
    id: 10,
    path: '/create-blog-guideline',
    label: 'Create Ai Persona',
    element: <CreateAiPersonaPage />,
    layout: 'private'
  },
  // {
  //   id: 11,
  //   path: "/style-guide",
  //   label: "Style Guide",
  //   element: <StyleGuidePage />,
  //   layout: "private",
  // },
  // {
  //   id: 12,
  //   path: "/create-style-guide",
  //   label: "Create Style Guide",
  //   element: <CreateStyleGuidePage />,
  //   layout: "private",
  // },
  {
    id: 13,
    path: '/ai-model',
    label: 'Ai Model',
    element: <AiModelPage />,
    layout: 'private'
  },
  {
    id: 14,
    path: '/account',
    label: 'Account',
    element: <AccountPage />,
    layout: 'private'
  },
  {
    id: 18,
    path: '/profile',
    label: 'Profile',
    element: <ProfilePage />,
    layout: 'private'
  },
  {
    id: 15,
    path: '/verify-email',
    label: 'Verify Email',
    element: <VerifyEmail />,
    layout: 'public'
  },
  {
    id: 15,
    path: '/plan-checkout',
    label: 'Checkout',
    element: <CardDetails />,
    layout: 'private'
  },
  {
    id: 16,
    path: '/blog-journey',
    label: 'Blog Journey',
    element: <BlogJourneyPage />,
    layout: 'public'
  },
  {
    id: 17,
    path: '/support-tickets',
    label: 'Support Tickets',
    element: <SupportTicketsPage />,
    layout: 'private'
  },
  {
    id: 19,
    path: '/blog-auditor/:id?',
    label: 'Blog Auditor',
    element: <GeoScanPage />,
    layout: 'private'
  },
  {
    id: 20,
    path: '/blog-auditor-public/:id?',
    label: 'Blog Auditor',
    element: <GeoScanPage />,
    layout: 'public'
  },
  {
    id: 21,
    path: '/aeo-auditor/:id?',
    label: 'AEO Auditor',
    element: <AeoScanPage />,
    layout: 'private'
  },
  {
    id: 22,
    path: '/aeo-auditor-public/:id?',
    label: 'AEO Auditor',
    element: <AeoScanPage />,
    layout: 'public'
  }
];

export default routes;
